<template>
    <div>
        <Card :padding="0">
            <p slot="title" class="card-title">
                <Icon type="map"></Icon>
                最近30天日活跃用户数-分产品
            </p>
            <div style="height: 360px">
                <div style="width:100%;height:100%;" id="data_source" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>
<script>
    import {findActiveUser} from "../../../service/api.js";

    export default {
        name: "day-active-num",
        data () {
            return {
                isShow: false, //是否显示缺醒图
                activeList: [
                    //活跃用户数集合
                    {
                        type: 1,
                        name: "大屏",
                        dataList: [] //日期集合
                    },
                    {
                        type: 2,
                        name: "移动授课助手",
                        dataList: []
                    },
                    {
                        type: 3,
                        name: "备课助手",
                        dataList: []
                    },
                    {
                        type: 4,
                        name: "智能PC",
                        dataList: []
                    }
                ]
            };
        },
        methods: {
            /**
             * 最近30天日活跃用户数-分产品接口集成
             */
            async findActiveUser () {
                let _this = this;
                await findActiveUser()
                    .then(function (data) {
                        _this.activeList = data;
                        _this.initDataSource();
                        _this.isShow = _this.activeList.length <= 0;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 最近30天日活跃用户数-分产品数据获取
             */
            initDataSource () {
                let dataSource = this.$echarts.init(
                    document.getElementById("data_source")
                );
                let dateArr = [];
                let proNameArr = [];
                let dataList = [];
                for (let i = 0; i < this.activeList.length; i++) {
                    proNameArr.push(this.activeList[i].name);
                    let obj = {};
                    obj.name = this.activeList[i].name;
                    obj.type = this.activeList[i].type==0?"line":"bar";
                    obj.stack = this.activeList[i].type==0?"":"总量";
                    obj.barWidth = 18;
                    obj.barGap = 1;
                    let data = [];
                    for (let j = 0; j < this.activeList[i].timeList.length; j++) {
                        if (this.activeList[i].type == 1) {
                            dateArr.push(this.activeList[i].timeList[j].time);
                        }
                        data.push(this.activeList[i].timeList[j].count);
                    }
                    obj.data = data;
                    dataList.push(obj);
                }
                const option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                        },
                        //自定义内容
                        formatter: function (params, ticket, callback) {
                            var htmlStr = '';
                            for (var i = 0; i < params.length; i++) {
                                var param = params[i];
                                var xName = param.name;//x轴的名称
                                var seriesName = param.seriesName;//图例名称
                                var value = param.value;//y轴值
                                var color = param.color;//图例颜色

                                if (i === 0) {
                                    htmlStr += xName + '<br/>';//x轴的名称
                                }
                                htmlStr += '<div>';
                                //为了保证和原来的效果一样，这里自己实现了一个点的效果
                                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';

                                //圆点后面显示的文本
                                htmlStr += seriesName + '：' + value + '人使用';

                                htmlStr += '</div>';
                            }
                            return htmlStr;
                        }
                    },
                    xAxis: {
                        type: "category",
                        data: dateArr,
                        axisLabel: {
                            interval: 0,
                            rotate: 40
                        }
                    },
                    yAxis: {
                        type: "value"
                    },
                    legend: {
                        data: proNameArr,
                        align: "left",
                        left: 0
                    },
                    color: [
                        "#FACBC0",
                        "LightPink",
                        "Moccasin",
                        "LightBlue",
                        "#DDA0DD",
                        "#60c0dd"
                    ],
                    series: dataList
                };
                dataSource.setOption(option);
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            }
        },
        mounted () {
            this.findActiveUser();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/common";
</style>
